import * as actionTypes from './actionTypes';

export const removeMixBet=(bet)=>({
    type:actionTypes.REMOVE_MIX_BET,
    payload:bet
})